import { Card, CardContent } from '@/components/ui/card';
import { Loader2, AlertCircle } from 'lucide-react';
import type { IconGeneratorStatus } from '../hooks/useIconGenerator';

interface IconPreviewProps {
  status: IconGeneratorStatus;
  previewUrl: string | null;
  error: string | null;
}

export function IconPreview({ status, previewUrl, error }: IconPreviewProps) {
  if (status === 'idle') return null;

  return (
    <Card>
      <CardContent className="pt-6">
        <h3 className="text-sm font-medium mb-3">Preview</h3>

        {status === 'generating' && (
          <div className="flex flex-col items-center justify-center h-64 text-muted-foreground">
            <Loader2 className="h-8 w-8 animate-spin mb-3" />
            <p className="text-sm">Generating icon...</p>
            <p className="text-xs mt-1">This typically takes 15-30 seconds</p>
          </div>
        )}

        {status === 'error' && (
          <div className="flex flex-col items-center justify-center h-64 text-destructive">
            <AlertCircle className="h-8 w-8 mb-3" />
            <p className="text-sm">{error || 'Generation failed'}</p>
          </div>
        )}

        {(status === 'generated' || status === 'saving' || status === 'saved') && previewUrl && (
          <div className="flex justify-center">
            <img
              src={previewUrl}
              alt="Generated icon preview"
              className="max-w-[256px] max-h-[256px] rounded-2xl shadow-lg"
            />
          </div>
        )}

        {status === 'saved' && (
          <p className="text-sm text-green-600 text-center mt-3">Icon saved to My-Fias/AI Images</p>
        )}
      </CardContent>
    </Card>
  );
}
